/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_DeletedInputs */

const en_jobs_deleted = /** @type {(inputs: Jobs_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job deleted`)
};

const de_jobs_deleted = /** @type {(inputs: Jobs_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stelle gelöscht`)
};

const fr_jobs_deleted = /** @type {(inputs: Jobs_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emploi supprimé`)
};

const es_jobs_deleted = /** @type {(inputs: Jobs_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empleo eliminado`)
};

const it_jobs_deleted = /** @type {(inputs: Jobs_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavoro eliminato`)
};

const nl_jobs_deleted = /** @type {(inputs: Jobs_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baan verwijderd`)
};

const pl_jobs_deleted = /** @type {(inputs: Jobs_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta usunięta`)
};

const fi_jobs_deleted = /** @type {(inputs: Jobs_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Työpaikka poistettu`)
};

const da_jobs_deleted = /** @type {(inputs: Jobs_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job slettet`)
};

const sv_jobs_deleted = /** @type {(inputs: Jobs_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobb raderat`)
};

/**
* | output |
* | --- |
* | "Job deleted" |
*
* @param {Jobs_DeletedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_deleted = /** @type {((inputs?: Jobs_DeletedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_DeletedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_deleted(inputs)
	if (locale === "fr") return fr_jobs_deleted(inputs)
	if (locale === "es") return es_jobs_deleted(inputs)
	if (locale === "it") return it_jobs_deleted(inputs)
	if (locale === "nl") return nl_jobs_deleted(inputs)
	if (locale === "pl") return pl_jobs_deleted(inputs)
	if (locale === "fi") return fi_jobs_deleted(inputs)
	if (locale === "da") return da_jobs_deleted(inputs)
	if (locale === "sv") return sv_jobs_deleted(inputs)
	return en_jobs_deleted(inputs)
});